import { GetSqlNumberResult } from "../../../../../../../queries/types";
import {
  OrderDirection,
  commonMutationTypes,
} from "../../../../../../../utils/commonQueryTypes";
import { IObjectKeys } from "../../../../../../../utils/formTypes";
import { PageInfo } from "../../../../../customer/settings/predefinedList/queries/types";
import { AtsRfqTrnEdge } from "../../queries/types";

export enum RfqQueryType {
  FINALIZED = "FINALIZED",
  NOT_FINALIZED = "NOT_FINALIZED",
}

export interface RfqListInitializationType {
  id: number;
  item_desc: string;
  required_quantity: number;
  terms: string;
  payment_terms: string;
  vendor_sl: number;
  quoted_qty: string;
  rate: number;
  any_other_charges: number;
  tax_perc: number;
  total_amount: number;
  others: number;
  net_quoted: number;
  remarks: string;
  upload_product_details: string;
  place_order: boolean;
  verbal_final_rate: number;
  taxes: number;
  order_qty: number;
  negotiation_by: string;
  verbal_final_amount: number;
}

export enum AtsRfqTrnOrderField {
  SL_NO = "SL_NO",
  TRN_DATE = "TRN_DATE",
  TRN_NEED_BEFORE = "TRN_NEED_BEFORE",
}

export interface AtsRfqTrnOrder {
  direction: OrderDirection;
  field: AtsRfqTrnOrderField;
}

export enum RfqTrnQueryType {
  ALL_ITEMS = "ALL_ITEMS",
  PENDING_ITEMS = "PENDING_ITEMS",
  APPROVED_ITEMS = "APPROVED_ITEMS",
  REJECTED_ITEMS = "REJECTED_ITEMS",
}

export interface GetRfqTrnsVar {
  token: string;
  customerId: number;
  finYrId: number;
  after: string | null;
  rfqID: number;
  supplierId: number;
  queryType: RfqTrnQueryType;
  orderBy: AtsRfqTrnOrder;
}

export interface AtsRfqTrnConnection {
  edges: AtsRfqTrnEdge[];
  pageInfo: PageInfo;
  totalCount: number;
}

export interface GetRfqTrnsResult {
  GetRfqTrns: AtsRfqTrnConnection;
}

export enum AtsRfqTrnSupplyOrderField {
  SL_NO = "SL_NO",
}

export interface AtsRfqTrnSupplyOrder {
  direction: OrderDirection;
  field: AtsRfqTrnSupplyOrderField;
}

export enum RfqSupplyQueryType {
  ALL = "ALL",
  SENT_FOR_QUOTE = "SENT_FOR_QUOTE",
  QUOTE_COMPLETED = "QUOTE_COMPLETED",
  NEGO_COMPLETED = "NEGO_COMPLETED",
  COMPLETED = "COMPLETED",
}
export interface GetRfqTrnSupplyVar {
  token?: string;
  customerId: number;
  finYrId: number;
  rfqId: number;
  queryType: RfqSupplyQueryType;
  start_date: string;
  end_date: string;
  after: string | null;
  orderBy: AtsRfqTrnSupplyOrder;
  name: boolean
}

export interface AtsRfqTrn {
  id: number;
  slNo: number;
  trnDate: string;
  udfItemDesc: string;
  trnQty: number;
  approxRate: number;
  priority: string;
  preferredSupplierIds: string;
  trnNeedBefore: string;
  itemTerms: string;
  itemPaymentTerms: string;
}

export interface AtsRfqTrnSupply {
  id: number;
  slNo: number;
  rfqTrnSlNo: number;
  isAccepted: boolean;
  itemDescChanged: boolean;
  quotedAnyChanges: boolean;
  quotedDesc: string;
  quotedQty: number;
  quotedRate: number;
  quotedOther: number;
  quotedTaxable: number;
  quotedTax: number;
  quotedDelvChrg: number;
  quotedInstChrg: number;
  quotedValue: number;
  quotedRemarks: string;
  quotedProductBrochure: string;
  negoStatus: boolean;
  negoQty: number;
  negoRate: number;
  negoOther: number;
  negoTaxable: number;
  negoTax: number;
  negoDelvChrg: number;
  negoInstChrg: number;
  negoValue: number;
  negoRemarks: string;
  customerID: number;
  itemID: number;
  rfqTrnID: number;
  rfqID: number;
  finYrID: number;
  ldgrID: number;
  rfq: {
    rfqNo:string
  };
  rfqTrn: AtsRfqTrn;
}

export interface AtsRfqTrnSupplyEdge {
  node: AtsRfqTrnSupply;
  cursor: string;
}

export interface AtsRfqTrnSupplyConnection {
  edges: AtsRfqTrnSupplyEdge[];
  pageInfo: PageInfo;
  totalCount: number;
}

export interface GetRfqTrnSupplyResult {
  GetRfqTrnSupply: AtsRfqTrnSupplyConnection;
}

export interface RfqTrnSupplyByNodeResult {
  map(arg0: ({ node }: { node: any }) => { item_desc: any }): unknown;
  RfqTrnSupplyByNodeResult: boolean;
}

export interface RfqTrnSupplyByNodeVar {
  token?: string;
  id: number;
}

export interface itemInitialValuesType extends IObjectKeys {
  item_desc: string;
  required_qty: number;
  terms: string;
  payment_terms: string;
}

export interface vendorQuotedDetailsInitialValuesType extends IObjectKeys {
  quoted_company: string;
  vendor_item_desc: string;
  quoted_qty: number;
  rate: number;
  any_other_charges: boolean;
  tax_perc: number;
  total_amount: number;
  others: number;
  net_quoted: number;
  remarks: string;
}

export interface UpdateRfqTrnSupplyNegoResult {
  UpdateRfqTrnSupplyNegoResult: boolean;
}

export interface UpdateNegoPrices {
  rfqTrnSupplyId: number;
  negoQty: number;
  negoRate: number;
  negoOther: number;
  negoTaxable: number;
  negoTax: number;
  negoDelvChrg: number;
  negoInstChrg: number;
  negoValue: number;
  negoRemarks: string;
}

export interface UpdateRfqTrnSupplyNegoVar extends commonMutationTypes {
  customerId: number;
  finYrId: number;
  input: UpdateNegoPrices[];
}
